<template>
  <div class="missions-page">
    <headerSection v-if="!standalonePreview" />
    <main class="missions-page__main">
      <div class="missions-page__top">
        <router-link :to="backRoute">←</router-link>
        <div><small>เป้าหมายเพื่อคู่หู</small><h1>ภารกิจ FUN Buddy</h1></div>
      </div>
      <div v-if="loading" class="missions-page__state">กำลังรวมภารกิจ...</div>
      <div v-else-if="error" class="missions-page__state"><strong>{{ error }}</strong><router-link to="/">กลับหน้าหลัก</router-link></div>
      <template v-else-if="status">
        <div v-if="notice" class="mission-notice">{{ notice }}</div>
        <section class="mission-summary">
          <div><small>ยอดฝากสำเร็จวันนี้</small><strong>{{ money(status.todayDeposit) }} บาท</strong></div>
          <div><small>ยอดฝากสัปดาห์นี้</small><strong>{{ money(status.weekDeposit) }} บาท</strong></div>
          <div><small>รางวัลพร้อมรับ</small><strong>{{ status.claimableCount }} รายการ</strong></div>
        </section>
        <QilinMissionGroup title="ภารกิจรายวัน" subtitle="รีเซ็ตทุกวันเวลา 00:00 น." :missions="status.daily" :claiming="claiming" @claim="claim" />
        <QilinMissionGroup title="ภารกิจรายสัปดาห์" subtitle="นับวันจันทร์–อาทิตย์" :missions="status.weekly" :claiming="claiming" @claim="claim" />
        <p class="missions-page__note">หมายเหตุ: ภารกิจเช็กอินนับเมื่อฝากสำเร็จครบ {{ status.minDeposit }} บาทและกดให้อาหารแล้ว</p>
      </template>
    </main>
    <footerSection v-if="!standalonePreview" />
  </div>
</template>

<script>
import qilinApi, { qilinErrorMessage, qilinPreviewEnabled } from '../services/qilinRetention'
import QilinMissionGroup from '../components/qilin/QilinMissionGroup.vue'

export default {
  name: 'QilinMissions',
  components: { QilinMissionGroup, headerSection: () => import('./Header.vue'), footerSection: () => import('./Footer.vue') },
  data () { return { status: null, loading: true, claiming: '', notice: '', error: '' } },
  computed: {
    standalonePreview () { return qilinPreviewEnabled && this.$route.query.preview === 'standalone' },
    backRoute () { return this.standalonePreview ? { path: '/pet', query: { preview: 'standalone' } } : '/' }
  },
  mounted () { this.load() },
  methods: {
    money (value) { return Number(value || 0).toLocaleString() },
    async load () {
      this.loading = true
      try { this.status = await qilinApi.getMissionsStatus() } catch (error) { this.error = qilinErrorMessage(error) } finally { this.loading = false }
    },
    async claim (missionId) {
      this.claiming = missionId
      this.notice = ''
      try {
        const response = await qilinApi.claimMission(missionId)
        this.notice = `รับรางวัลสำเร็จ ${response.coin} เหรียญ + ${response.xpGained} XP${response.levelCoinBonus ? ` · โบนัสเลเวล ${response.levelCoinBonus} เหรียญ` : ''}`
        this.status = await qilinApi.getMissionsStatus()
      } catch (error) { this.notice = qilinErrorMessage(error) } finally { this.claiming = '' }
    }
  }
}
</script>

<style scoped>
.missions-page { min-height: 100vh; background: radial-gradient(circle at 50% 12%,#10245a,#03051b 42%); color: #fff; font-family: 'Kanit',sans-serif; }
.missions-page__main { width: min(1040px,calc(100% - 28px)); min-height: 76vh; margin: auto; padding: 105px 0 48px; }
.missions-page__top { display: flex; align-items: center; gap: 12px; margin-bottom: 18px; }
.missions-page__top > a { display: grid; width: 40px; height: 40px; place-items: center; border: 1px solid rgba(255,255,255,.1); border-radius: 13px; color: #fff; text-decoration: none; }
.missions-page__top small { color: #68dec0; font-size: 11px; font-weight: 900; }
.missions-page__top h1 { margin: 0; font-size: 25px; }
.missions-page__state { min-height: 430px; display: grid; align-content: center; justify-items: center; gap: 10px; color: rgba(255,255,255,.65); }
.missions-page__state a { color: #ffd85d; }
.mission-notice { margin-bottom: 13px; padding: 11px 14px; border: 1px solid rgba(103,219,189,.22); border-radius: 13px; background: rgba(103,219,189,.09); color: #baf8e7; font-size: 13px; }
.mission-summary { display: grid; grid-template-columns: repeat(3,1fr); gap: 10px; margin-bottom: 16px; }
.mission-summary > div { padding: 14px; border: 1px solid rgba(255,255,255,.08); border-radius: 16px; background: rgba(255,255,255,.05); }
.mission-summary small, .mission-summary strong { display: block; }
.mission-summary small { color: rgba(255,255,255,.48); font-size: 10px; }
.mission-summary strong { margin-top: 3px; color: #ffe17a; font-size: 17px; }
.missions-page__note { margin: 16px 3px 0; color: rgba(255,255,255,.42); font-size: 11px; }
@media (max-width: 700px) { .mission-summary { grid-template-columns: 1fr; } .missions-page__main { padding-top: 24px; } }
</style>
